
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Change the placeholder text of the autocomplete menu
    options.placeholder = "Search";
    return options;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function (options) {
    options.hitsPerPage = 36;
    /*options.paginationLimitedTo	= 5000;*/
    return options;
  });

  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
    const {
      searchBox,
      stats
    } = window.algoliaShopify.externals.widgets;

    // Manually access infiniteHits from instantsearch.widgets
    const infiniteHits = window.instantsearch.widgets.infiniteHits;
    
    const searchBoxWidget = searchBox({
      container: '#search-box'
    });

    const infiniteHitsWidget = infiniteHits({
      container: '.ais-hits-container',
      showPrevious: false,
      templates: {
        item(hit, { html, components }) {
          //if(hit.vendor == 'Wendelbo') { Commenting as per Emilly on 17-10-2025
            hit.distinct = true;// Used to display product's main image in collection page
          //}

          const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
          const localDistinct = hit.variants_count > 1 ? hit._distinct : false;
          const variantTitle = localDistinct !== false ? hit.variant_title : '';

          return html`
            <div class="ais-hit ais-product" 
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              data-handle="${hit.handle}"
              data-product-id="${hit.id}">
              <div class="ais-hit--picture"><img src="${hitImage.src}" alt="${hit.title}" />${hit.price_ratio !== 1 && html`<div class="ais-Discount-label">${html`<span class="ais-hit--price-discount">${displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)}</span>`}</div>`}</div>
              <div class="ais-hit--details">
                <p
                  class="ais-hit--subtitle"
                  title="${hit.vendor}${algoliaShopify.translation_helpers.by(
                    hit.vendor
                  )}"
                >
                  ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
                </p>
                
                <div class="ais-hit--price-div">
                  <p class="ais-hit--price"> 
                    ${hit.variants_min_price == hit.variants_max_price ? algoliaShopify.formatMoney(Number(hit.variants_min_price) * 100) : html`From: ${algoliaShopify.formatMoney(Number(hit.variants_min_price) * 100)}`}
                  </p>
                  <p class="ais-hit--price--strikethrough">
                    ${hit._distinct && html`<span class="ais-hit--price-striked"><span>${hit.price == hit.variants_min_price && hit.price_ratio !== 1 && algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span></span>`}
                  </p>
                  ${hit.price_ratio !== 1 && html`<p class="ais-hit--price--mobile">${algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)} </p>`}
                </div>
                <p class="ais-hit--title">
                  <a
                    data-algolia-index="${hit.index}"
                    data-algolia-position="${hit.productPosition}"
                    data-algolia-queryid="${hit.queryID}"
                    data-algolia-objectid="${hit.objectID}"
                    href="${instantsearchLink(hit)}"
                    title="${fullTitle(
                      hit.title,
                      hit._distinct,
                      hit.variant_title
                    )}"
                  >
                    ${components.Highlight({ attribute: 'title', hit })}
                    ${variantTitleAddition(hit, hit._distinct)}
                  </a>
                </p>
              </div>
            </div>
          `;
        },
        /*loadMore({ isLastPage }, { html }) {
          if (isLastPage) return ''; // 🔍 Don't render anything on last page
    
          return html`
            <button class="ais-InfiniteHits-loadMore custom-load-more" onclick="handleLoadMoreClick(event)">
              Show more results
            </button>
          `;
        }*/
      }
      
    });

    const handleLoadMoreBehaviorWidget = {
      init() {
        // Ensure button is hidden initially if needed
        const btn = document.querySelector('.ais-InfiniteHits-loadMore');
        if (btn) btn.style.display = 'none';
      },
      render({ results }) {
        const loadMoreButton = document.querySelector('.ais-InfiniteHits-loadMore');
        const hitsContainer = document.querySelector('.ais-hits-container');
        const isLastPage = results.page + 1 >= results.nbPages;
        const hasHits = results.hits.length > 0;
        let previousScrollY = 0;
    
        // Show/hide button based on content
        if (loadMoreButton) {
           loadMoreButton.style.display = 'none';
           setTimeout(() => {
            loadMoreButton.style.display = (hasHits && !isLastPage) ? 'block' : 'none';
           }, 500);
    
          // Attach listener once to prevent scroll on click
          if (!loadMoreButton.dataset.listenerAdded) {
            loadMoreButton.dataset.listenerAdded = 'true'; // flag to prevent duplicate

            loadMoreButton.addEventListener('pointerdown', (e) => {
                e.preventDefault();    
                previousScrollY = window.scrollY;
            });
    
            loadMoreButton.addEventListener('click', (e) => {
              const scrollTop = window.scrollY;
              // Prevent scroll jump by blurring the button
              e.currentTarget.blur();
              loadMoreButton.style.display = 'none';
              e.preventDefault();               

              setTimeout(() => {
                window.scrollTo(0, previousScrollY);
              }, 100);
            });
          }
        }
      }
    };

    return [
      searchBoxWidget,
      infiniteHitsWidget,
      handleLoadMoreBehaviorWidget 
    ];
  });

  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(defaultWidgets) {
    // Find and return the default pagination widget
    const defaultPaginationWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.pagination'
    );

    return [defaultPaginationWidget];
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function(_defaultFilter) {
    // Don't return the default filter and return a custom filter
    if(_defaultFilter == '') {
      _defaultFilter = 'NOT product_type:"_Custom Product" AND NOT product_type:"OPTIONS_HIDDEN_PRODUCT" AND NOT product_type:"_OPTIONS_HIDDEN_PRODUCT" AND NOT tags:*hidesearch';
    } else {
      _defaultFilter+= ' AND NOT product_type:"_Custom Product" AND NOT product_type:"OPTIONS_HIDDEN_PRODUCT" AND NOT product_type:"_OPTIONS_HIDDEN_PRODUCT" AND NOT tags:*hidesearch';
    }

    return _defaultFilter;
   });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter) {
    // Modify or replace the default string, then return a string
   if(defaultFilter == '') {
      defaultFilter = 'NOT product_type:"_Custom Product" AND NOT product_type:"OPTIONS_HIDDEN_PRODUCT" AND NOT tags:*hidesearch';
    } else {
      defaultFilter+= ' AND NOT product_type:"_Custom Product" AND NOT product_type:"OPTIONS_HIDDEN_PRODUCT" AND NOT tags:*hidesearch';
    }

    return defaultFilter;
   });

  // Collection page
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    let window_w = window.innerWidth;
    let btn_text = window_w > 1024 ? 'Hide Filter' : 'Show Filter';
    let hide_class = window_w > 1024 ? '' : 'hide-filter';

    var btnStringConfigurator = 'hide';
    if(stringConfigurator === true) {
      btnStringConfigurator = `hide`;// Not available in DDS
    }

    if(searchTitle.includes('Brand:')) {
      var isBrandCollection = false;
    } else {
      var isBrandCollection = false;
    }
    return html`
      <div class="ais-page ${hide_class}">
          <div class="ais-facets-button">
            Show filters
          </div>
          <div class="ais-top">
            <div class="ais-top-left">
              <button class="hide-filter-btn"><span>${btn_text}</span></button>
              <label class="ais-quick-show-btn"><input type="checkbox" id="ais-quick-show-input" /> <span class="icon"></span> <span class="label">Quick Ship</span></label>
            </div>
            
            <div class="ais-top-right">
              ${!isBrandCollection?
                  html`<h1 class="ais-h2">${searchTitle}</h1>`
                  :  html``
                }
              <a class="clsBtnStringConfig ${btnStringConfigurator}" href="/pages/string-furniture-configurator">Configure Your Own String Furniture</a><br clear="all"/>
              <div class="invSaleDiv">${invSaleMsg}</div>
            </div>
            
          </div>
          <div class="ais-facets">
            
        ${data.facets.map( facet =>
          html`<div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</label>
                <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
              </div>`
        )}
          </div>
          <div class="ais-block">
            <div class="ais-page-search-wrapper">
              
              <div class="ais-input">
                <div class="ais-search-box-container"></div>
                <div class="ais-input-button">
                  <div class="ais-clear-input-icon"></div>
                </div>
              </div>
            </div>
  
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
                <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders ?
                  html`${algoliaShopify.translations.sortBy} <span class="ais-sort-orders-container"></span>`
                  : html`${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance}`
                }
              </div>
            </div>
            <div class="ais-current-refined-values-container-wrapper">
              <div class="ais-clear-refinements-container"></div>
              <div class="ais-current-refined-values-container"></div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
            <div class="ais-pagination-container"></div>
          </div>
        </div>
    `;
  });


  // Product List under collection
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, trackSearchAttribution) {
    var localDistinct = hit._distinct;
    //if(hit.vendor == 'Wendelbo') {
      hit.distinct = true;// Used to display product's main image in collection page
    //}
    const checkboxes = document.querySelectorAll('.ais-facet--checkbox:checked');
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250);

    checkboxes.forEach(function(checkbox) {
        // Get the parent element of the checkbox and check its text content
        if (checkbox.parentNode.textContent.indexOf("weeks") === -1) {
            localDistinct = false;
        }
    });
    
    hit._qsDistinct = (hit.variants_count > 1) ? localDistinct : hit._distinct;
    hit.variant_title = (localDistinct !== false) ? hit.variant_title : '';

    
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="javascript:void(0);"
      >
        <div class="ais-hit--picture">
        <img
          class="ais-hit--picture"
          src="${hitImage.src}"
          srcset="${hitImage.srcset}"
          sizes="${hitImage.sizes}"
          alt="${hit.title} - ${hit.variant_title}"
        />
        ${hit.price_ratio !== 1 && html`<div class="ais-Discount-label">${hit._distinct && html`<span class="ais-hit--price-discount">${displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)}</span>`}</div>`}
        </div>

        <div class="ais-hit--details">
          <p
            class="ais-hit--subtitle"
            title="${hit.vendor}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          
          <div class="ais-hit--price-div">
            <p class="ais-hit--price"> 
              ${hit.variants_min_price == hit.variants_max_price ? algoliaShopify.formatMoney(Number(hit.variants_min_price) * 100) : html`From: ${algoliaShopify.formatMoney(Number(hit.variants_min_price) * 100)}`}
            </p>
            <p class="ais-hit--price--strikethrough">
              ${hit._distinct && html`<span class="ais-hit--price-striked"><span>${hit.price == hit.variants_min_price && hit.price_ratio !== 1 && algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span></span>`}
            </p>
            ${hit.price_ratio !== 1 && html`<p class="ais-hit--price--mobile">${algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)} </p>`}
          </div>
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${instantsearchLink(hit)}"
              title="${fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          
          
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function(_defaultTemplate, html) {
    return html`
      <div class="ais-hit-empty">
        <div class="ais-hit-empty--title">
          ${algoliaShopify.translations.noResultFound}
        </div>
        <div class="ais-hit-empty--clears">
          ${algoliaShopify.translations.try} ${' '}
          <a class="ais-hit-empty--clear-filters ais-link">
            ${algoliaShopify.translations.clearFilters} ${' '}
          </a>
          ${algoliaShopify.translations.or} ${' '}
          <a class="ais-hit-empty--clear-input ais-link">
            ${algoliaShopify.translations.changeInput}
          </a>
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate", function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them
    const { html, item, components } = templateOptions;
    //if(item.vendor == 'Wendelbo') {
        item.distinct = true;// Used to display product's main image in collection page
    //}
    return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.renderImage(item, 125).src}"
            srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
            sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${
              item.product_type &&
              components.Highlight({ hit: item, attribute: "product_type" })
            } by ${components.Highlight({ hit: item, attribute: "vendor" })}
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
  });
});

document.querySelector('body').addEventListener('click', function (evt) {
    if (evt.target.className === 'hide-filter-btn') {
        if(document.querySelector('.ais-page').classList.contains("hide-filter")) {  
          document.querySelector('.ais-page').classList.remove("hide-filter");
          document.querySelector('.ais-facets').style.display = 'block'; 
          //document.querySelector(e.currentTarget).innerHTML = '<span>Hide Filter</span>';
          evt.target.innerHTML = '<span>Hide Filter</span>';
        } else {  
          document.querySelector('.ais-page').classList.add("hide-filter");
          document.querySelector('.ais-facets').style.display = 'none'; 
          //document.querySelector(e.currentTarget).innerHTML = '<span>Show Filter</span>';
          evt.target.innerHTML = '<span>Show Filter</span>';
        }
    } else if (event.target && event.target.classList.contains('ais-current-refined-values--link')) {    
      // Get the value of the 'data-value' attribute and convert it to lowercase
      let text = event.target.getAttribute('data-value').toLowerCase();
      // Decode the URI and check if it matches "Quick Ship"
      if (decodeURI(text) === "true") {
        // Find the element with the ID 'ais-quick-show-input' and set its 'checked' property to false
        document.getElementById('ais-quick-show-input').checked = false;
      }
    }
}, false);

// Add an event listener for the 'change' event on the input element
document.body.addEventListener('change', function(event) {
  // Check if the target element has the ID 'ais-quick-show-input'
  if (event.target && event.target.id === 'ais-quick-show-input') {
    // Find all elements with the class 'ais-facet--label'
    const labels = document.querySelectorAll('.ais-facet--label');
    
    // Iterate over the NodeList of labels
    labels.forEach(function(label) {
      // Check if the label's text content matches "quick ship"
      if (label.textContent.trim().toLowerCase().includes("true")) {        
        label.click();

        /*setTimeout(function() {
          const divs = document.querySelectorAll('.ais-current-refined-values--link');
          console.log('divs', divs);
          divs.forEach(function(div) {
            console.log('div', div);
            div.outerHTML = div.outerHTML.replace('true', 'Quick Ship');
          });  
        }, 500);*/
      }
    });
  }
}, false);

window.addEventListener('load', function(event) {
  const facetLoaded = document.getElementById('price_range');
  if (facetLoaded) {
    onReady();
  }

  document.querySelector('.ais-InfiniteHits-loadMore')?.addEventListener('click', (e) => {
    e.currentTarget.blur(); // Remove focus immediately
  });
});

function onReady() {
  setTimeout(()=> {
    if(decodeURIComponent(window.location.search.toLowerCase()).includes('named_tags.quickship')) {
      document.getElementById('ais-quick-show-input').checked = true;
    } else if(decodeURIComponent(window.location.pathname.toLowerCase()).includes('quick-ship')) {
      //document.getElementById('ais-quick-show-input').click();
      document.getElementById('ais-quick-show-input').checked = true;
      const labels = document.querySelectorAll('.ais-facet--label');
      labels.forEach(function(label) {
        // Check if the label's text content matches "quick ship"
        if (label.textContent.trim().toLowerCase().includes("true")) {
           label.click();
        }
      });
    } 
  }, 500);
}

function displayDiscount(price, compare_at_price, price_ratio) {
  const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
  const discount_ratio = 1.0 - price_ratio;
  if (comparing) { return `${Math.round(discount_ratio * 100)}% Off`}
}

function fullTitle(title, distinct, variant_title) {
  var res = title;
  /*if (
    !distinct &&
    variant_title &&
    variant_title !== 'Default Title' &&
    variant_title !== 'Default'
  ) {
    res += ' (' + variant_title + ')';
  }*/

  return escapeHtml(res);
}

function variantTitleAddition(item, distinct) {
  var res = ' ';
  /*if (
    !distinct &&
    item.variant_title &&
    item.variant_title !== 'Default Title' &&
    item.variant_title !== 'Default'
  ) {
    res += `( ${item.variant_title} )`;
  }*/
  return res;
}

function instantsearchLink(hit) {
  if(hit._qsDistinct === false) {
      return (
        '/products/' +
        hit.handle + '?variant=' + hit.objectID);
  } else {
  const addVariantId = !hit._distinct && hit.objectID !== hit.id;
    return (
        '/products/' +
        hit.handle +
        (addVariantId ? '?variant=' + hit.objectID : '')
    );
  }
}

var escapeHtml = function escapeHtml(unsafe) {
  return (unsafe || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

var alge = { helpers: {} };  // Assuming `e.helpers` is an object

[
  'pico',
  'icon',
  'thumb',
  'small',
  'compact',
  'medium',
  'large',
  'grande',
  'original'
].forEach(function(size) {
  alge.helpers[size + 'Image'] = function(item) {
    var image = item.product_image || item.image;  // Check product_image first

    if (!image) {
      return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
    }

    if (size === 'original') {
      return image;
    }

    return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
  };
});